import { apiClient } from "../apiClient";
import { IChangePasswordRequest } from "../../model/request/auth/IChangePasswordRequest";
import { IDevResetPasswordRequest } from "../../model/request/auth/IDevResetPasswordRequest";
import { ILoginRequest } from "../../model/request/auth/ILoginRequest";
import { ILoginRespone, IUserInfo } from "../../model/respone/auth/ILoginRespone";

export const authApi = {
    Login: (req: ILoginRequest) => apiClient.post<ILoginRespone>("auth/login", req),
    Me: () => apiClient.get<IUserInfo>("auth/me"),
    ChangePassword: (req: IChangePasswordRequest) =>
        apiClient.post<{ message: string }>("auth/change-password", req),
    DevResetPassword: (req: IDevResetPasswordRequest) =>
        apiClient.post<{ message: string }>("auth/dev-reset-password", req),
};
